import { Injectable, EventEmitter } from "@angular/core"

import {
  SignalRService,
  SignalREventService,
  Model,
  Equipment,
  PoweredBy,
  Company,
  Minesite,
  User,
  DataArray,
  GlobalService,
  ToastrService,
} from "./../index"

@Injectable()
export class PartsManualService {
  public equipmentChange: EventEmitter<Equipment[]> = new EventEmitter<
    Equipment[]
  >()
  public modelChange: EventEmitter<Model[]> = new EventEmitter<Model[]>()
  public powerdByChange: EventEmitter<PoweredBy[]> = new EventEmitter<
    PoweredBy[]
  >()
  public minesiteChange: EventEmitter<Minesite[]> = new EventEmitter<
    Minesite[]
  >()
  public companyChange: EventEmitter<Company[]> = new EventEmitter<Company[]>()
  public models: DataArray<Model> = new DataArray<Model>()
  public poweredBys: DataArray<PoweredBy> = new DataArray<PoweredBy>()
  public companies: DataArray<Company> = new DataArray<Company>()
  public minesites: DataArray<Minesite> = new DataArray<Minesite>()
  public equipments: DataArray<Equipment> = new DataArray<Equipment>()
  public totalEquipments = 0

  constructor(
    private _signalRService: SignalRService,
    private _signalREventService: SignalREventService
  ) {
    this.equipments.init()
    this.registerOnServerEvents()
  }

  public getAllEquipments(
    selectedModel: number,
    selectedPoweredBy: number,
    selectedCompany: number,
    selectedMinesite: number,
    serial: string
  ): void {
    this.equipments = new DataArray<Equipment>()
    this._signalRService.invoke(
      "GetEquipmentsForPartsManual",
      selectedModel,
      selectedPoweredBy,
      selectedCompany,
      selectedMinesite,
      serial
    )
  }

  public getAllModels(): void {
    this.models = new DataArray<Model>()
    this._signalRService.invoke("GetModelsForPartsManual")
  }

  public getPoweredByForModel(selectedModel: number): void {
    this._signalRService.invoke(
      "GetPoweredByForModel_PartsManual",
      selectedModel
    )
  }

  public getCompaniesByModelAndPoweredBy(
    selectedModel: number,
    selectedPoweredBy: number
  ): void {
    this._signalRService.invoke(
      "GetCompaniesByModelAndPoweredBy_PartsManual",
      selectedModel,
      selectedPoweredBy
    )
  }

  public getMinesitesByModelAndPoweredByAndCompany(
    selectedModel: number,
    selectedPoweredBy: number,
    selectedCompany: number
  ): void {
    this._signalRService.invoke(
      "GetMinesitesByModelAndPoweredByAndCompany_PartsManual",
      selectedModel,
      selectedPoweredBy,
      selectedCompany
    )
  }

  public saveURL(
    serial: string,
    partsURL: string,
    edURL: string,
    selectedModel: number,
    selectedPoweredBy: number,
    selectedCompany: number,
    selectedMinesite: number,
    filterSerial: string
  ): void {
    this.equipments = new DataArray<Equipment>()
    this._signalRService.invoke(
      "SaveEquipmentsForPartsManual",
      serial,
      partsURL,
      edURL,
      selectedModel,
      selectedPoweredBy,
      selectedCompany,
      selectedMinesite,
      filterSerial
    )
  }

  private onEquipments(info: any): void {
    this.equipments.Clear()
    for (const item of info.Data.Equipments) {
      const equipment: Equipment = $.extend(new Equipment(), item)
      this.equipments.push(equipment)
    }
    this.equipmentChange.emit(this.equipments.Data)
  }

  private onModels(info: any): void {
    this.models.Clear()
    for (const item of info.Data.Models) {
      const model: Model = $.extend(new Model(), item)
      this.models.push(model)
    }
    this.modelChange.emit(this.models.Data)
  }

  private onPoweredBys(info: any): void {
    this.poweredBys.Clear()
    for (const item of info.Data.PoweredBys) {
      const poweredBy: PoweredBy = $.extend(new PoweredBy(), item)
      this.poweredBys.push(poweredBy)
    }
    this.powerdByChange.emit(this.poweredBys.Data)
  }

  private onMinesites(info: any): void {
    this.minesites.Clear()
    for (const item of info.Data.Minesites) {
      const minesite: Minesite = $.extend(new Minesite(), item)
      this.minesites.update(minesite, true)
    }
    this.minesiteChange.emit(this.minesites.Data)
  }

  private onCompanies(info: any): void {
    this.companies.Clear()
    for (const item of info.Data.Companies) {
      const company: Company = $.extend(new Company(), item)
      this.companies.update(company, true)
    }
    this.companyChange.emit(this.companies.Data)
  }

  private registerOnServerEvents() {
    this._signalREventService.register(
      "PartsManualService",
      "equipmentsForPartsManual",
      (info: any) => this.onEquipments(info)
    )
    this._signalREventService.register(
      "PartsManualService",
      "modelsForPartsManual",
      (info: any) => this.onModels(info)
    )
    this._signalREventService.register(
      "PartsManualService",
      "poweredbysForPartsManual",
      (info: any) => this.onPoweredBys(info)
    )
    this._signalREventService.register(
      "PartsManualService",
      "minesitesForPartsManual",
      (info: any) => this.onMinesites(info)
    )
    this._signalREventService.register(
      "PartsManualService",
      "companiesForPartsManual",
      (info: any) => this.onCompanies(info)
    )
  }

  public deregisterOnServerEvents(): void {
    this._signalREventService.deregister("PartsManualService")
  }
}
